import React from "react";
import { Link as LinkS } from "react-scroll";
import { ReactComponent as CloseIcon } from "../../assets/closeicon.svg";

const Sidebar = ({ isopen, toggle }) => {
  return (
    <div
      className="grid fixed w-full min-h-full bg-gray-800 z-40 items-center top-0 left-0 transition-all ease-in-out duration-300"
      isopen={isopen}
      onClick={toggle}
    >
      <div
        className="text-red-400 absolute top-5 right-6 cursor-pointer"
        onClick={toggle}
      >
        <CloseIcon />
      </div>
      <div className="text-white items-center justify-center text-center -mt-40 ">
        <div className="grid grid-cols-1 text-xl cursor-pointer  space-y-6 ">
          <LinkS
            to="about"
            onClick={toggle}
            smooth={true}
            spy={true}
            offset={-70}
            duration={500}
          >
            About
          </LinkS>
          <LinkS
            to="workflow"
            onClick={toggle}
            smooth={true}
            spy={true}
            offset={-70}
            duration={500}
          >
            WorkFlow
          </LinkS>
          <LinkS
            to="skills"
            onClick={toggle}
            smooth={true}
            spy={true}
            offset={-70}
            duration={500}
          >
            Tech I Use
          </LinkS>
          <LinkS
            to="potfolio"
            onClick={toggle}
            smooth={true}
            spy={true}
            offset={-70}
            duration={500}
          >
            Potfolio
          </LinkS>

          <LinkS
            to="contact"
            onClick={toggle}
            smooth={true}
            spy={true}
            offset={-70}
            duration={500}
          >
            Contact
          </LinkS>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
